export const CATALOG_ITEM_STATUS = {
  OPEN: "Abierto",
  CLOSED: "Cerrado",
};
